<template>
  <form-base :hide-required-legend="true">
    <template v-slot:form>
      <v-form class="pt-6 mx-3 edit-appointment-form inline-fields" ref="form">
        <template v-if="loading">
          <v-progress-linear
            indeterminate
            :loading="loading"
            height="6"
            class="mt-6"></v-progress-linear>
          <h4 class="text-center mt-4 mb-12">Updating appointment ...</h4>
        </template>
        <template v-else>
          <div class="align-center d-flex" v-if="refNumSettings.isVisible">
            <h3 class="mr-4">
              {{ refNumSettings.displayName }}
              <help-icon-tooltip v-if="refNumSettings.helperText">
                {{ refNumSettings.helperText }}
              </help-icon-tooltip>
              :
            </h3>
            <auto-expandable-textarea
              v-model="refNumber"
              :label="refNumberPlaceholder"
              :placeholder="refNumberPlaceholder"
              validate-on-blur
              :rules="$validator.rules.required(refNumSettings.displayName)"
              required
              v-if="refNumSettings.isRequired">
            </auto-expandable-textarea>
            <auto-expandable-textarea
              v-else
              v-model="refNumber"
              :label="refNumberPlaceholder"
              :placeholder="refNumberPlaceholder"
              validate-on-blur>
            </auto-expandable-textarea>
          </div>
          <div class="px-7">
            <custom-fields
              v-model="customFields"
              :appointment="appointment"
              :warehouse="appointment.dock.warehouse"
              @toggle-confirm-button="toggleConfirmButton">
            </custom-fields>
          </div>
          <div class="d-flex mb-4">
            <h3 class="mr-4 mt-4">Appointment Notes:</h3>
            <rich-text-input
              v-model="notes"
              class="flex-fill"
              :editor-config="{
                plugins: ['Essentials', 'Paragraph'],
                toolbar: { items: [] }
              }"></rich-text-input>
          </div>
        </template>
      </v-form>
    </template>
    <template v-slot:form-actions>
      <action-group
        v-if="!loading"
        class="card-actions mt-8"
        confirm-label="Save Changes"
        @cancel="$emit('close')"
        @confirm="updateAppointment">
      </action-group>
    </template>
  </form-base>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
  mixins: [clickaway],
  props: {
    appointment: {
      type: Object,
      required: true
    }
  },
  computed: {
    refNumberPlaceholder() {
      return this.refNumSettings.helperText || this.refNumSettings.displayName;
    },
    refNumSettings() {
      return this.$refNumSettings(this.appointment.dock.warehouse);
    }
  },
  data() {
    return {
      disableConfirm: false,
      customFields: [],
      refNumber: '',
      notes: '',
      selectedCarrier: null,
      loading: false,
      warehouse: {},
      dock: {}
    };
  },
  mounted() {
    this.refNumber = this.appointment.refNumber;
    this.notes = this.appointment.notes;
    this.selectedCarrier = this.appointment.user;
    this.dock = this.appointment.dock || {};
    this.warehouse = { ...(this.appointment.dock?.warehouse || { docks: [] }), docks: [this.dock] };
  },
  methods: {
    toggleConfirmButton(disableButton) {
      this.disableConfirm = disableButton;
    },
    async updateAppointment() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        await axios
          .patch(`appointment/${this.appointment.id}`, {
            refNumber: this.refNumber,
            notes: this.notes,
            customFields: this.customFields,
            userId: this.selectedCarrier.id,
            loadTypeId: this.appointment.loadTypeId
          })
          .catch(err => {
            err;
            // TODO: if we don't catch this, then a "[Vue warn]" console.error output will occur,
            // which will cause Laser tests to fail.
            // The actual error handling is being done in the global axios mixin, I think?
          })
          .then(() => {
            this.$eventHub.$emit('appointment-updated');
            this.$store.dispatch('Appointments/trackMixpanelEvent', {
              entryPoint: 'Carrier Portal Details Page',
              changedBy: 'Carrier User',
              appointment: this.appointment,
              change: 'Details'
            });
            this.$emit('close');
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
};
</script>
